import React from "react";
import PropTypes from "prop-types";
import Toggle from "./Toggle";
import { ANNUAL, LEFT, MONTHLY, PLAN_TYPES, RIGHT } from "../sell/constants";
import { handleKeyPress } from "./helpers/keyPressHelpers";

const PlanToggle = ({ onToggle, selectedPlan }) => {
  return (
    <div
      data-amplitude={
        selectedPlan === ANNUAL
          ? "signedOutSellPageToggleAnnual"
          : "signedOutSellPageToggleMonthly"
      }
      onKeyPress={(event) => handleKeyPress(event, onToggle)}
      role="button"
      tabIndex={0}
      onClick={onToggle}
      className="lc-plan-toggle"
    >
      <span
        className={`plan-text monthly ${
          selectedPlan === MONTHLY ? "active" : ""
        }`}
      >
        Monthly
      </span>
      <Toggle alignment={selectedPlan === MONTHLY ? LEFT : RIGHT} />
      <span
        className={`plan-text annual ${
          selectedPlan === ANNUAL ? "active" : ""
        }`}
      >
        Annual <span className="best-value">(Best Value)</span>
      </span>
    </div>
  );
};

PlanToggle.propTypes = {
  onToggle: PropTypes.func,
  selectedPlan: PropTypes.oneOf(PLAN_TYPES).isRequired
};

PlanToggle.defaultProps = {
  onToggle: null
};

export default PlanToggle;
